import React from 'react';

/** The generic navigational row: label left, fact right. Index, collections, filters. */
export function ListRow({
  label, meta, sigil, accent, dim = false, divider = true, onClick, minHeight, style
}) {
  return (
    <div onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 'var(--bujo-space-3)',
      minHeight: minHeight || 'var(--bujo-tap-min)',
      borderBottom: divider ? '1px solid var(--bujo-rule-hairline)' : 'none',
      cursor: onClick ? 'pointer' : 'default', ...style
    }}>
      <span style={{
        flex: 1, minWidth: 0,
        font: 'var(--bujo-fw-regular) 14.5px/var(--bujo-lh-row) var(--bujo-font-mono)',
        color: dim ? 'var(--bujo-text-meta)' : accent || 'var(--bujo-text-primary)'
      }}>{sigil ? sigil : null}{label}</span>
      {meta ? (
        <span style={{
          flex: 'none',
          font: 'var(--bujo-fw-regular) 11.5px/var(--bujo-lh-tight) var(--bujo-font-mono)',
          color: 'var(--bujo-text-meta)'
        }}>{meta}</span>
      ) : null}
    </div>
  );
}
